const axios = require('axios')
const config = require('./config')

const defaults = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  json: true
}

// Use production API URL unless explicitly in development mode
const env = process.env.NODE_ENV === 'development' ? 'development' : 'production'
defaults.baseURL = config.default.environment[env].apiUrl

export default axios.create(defaults)
